/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useState } from 'react';
import { fleetNavItems } from '../../../utils/fleetPermissions';
import { Link, useLocation } from 'react-router-dom';
import util from '../../../utils/util';
import useActivityLogger from '../../../pages/useActivityLogger';

// Import icons
import bell from '../../assets/icons/bell-solid.svg';
import user from '../../assets/icons/user-solid.svg';
import gear from '../../assets/icons/gear-solid.svg';
import plus from '../../assets/icons/plus-solid.svg';
import circle from '../../assets/icons/circle-solid.svg';
import left from '../../assets/icons/circle-arrow-left-solid.svg';
import right from '../../assets/icons/circle-arrow-right-solid.svg';
import screw from '../../assets/icons/screwdriver-wrench-solid.svg';
import chart from '../../assets/icons/chart-column-solid.svg';
import paint from '../../assets/icons/paint-roller-solid.svg';
import truck from '../../assets/icons/truck-moving-solid.svg';
import business from '../../assets/icons/business-time-solid.svg';

const ICONS = { bell, user, gear, plus, circle, left, right, screw, chart, paint, truck, business };

let $ = window.$;

const NavIcon = ({ icon, alt }) => (
  <img
    src={ICONS[icon]}
    alt={alt}
    height={15}
    width={15}
    style={{ marginRight: '12px', verticalAlign: 'middle', filter: 'brightness(0.8)', transition: 'all 0.3s ease' }}
  />
);

export default function Leftnavs() {
  const location = useLocation();
  const [modules, setModules] = useState({});
  const [isTablet, setIsTablet] = useState(false);
  const [orientation, setOrientation] = useState('portrait');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [fleetOpen,   setFleetOpen]   = useState(false);
  const [captureOpen, setCaptureOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const fleetNav = fleetNavItems();
  // Regional admins see all fleet nav items — data is scoped server-side by IS_REGIONAL
  const fleetNavVisible = (key) => fleetNav[key] || fleetNav.isSuperUser || fleetNav.isRegional || fleetNav.isProgramme;

  // ── canSee: bypass all module checks for superusers / national admins ────────
  // Superadmin (role_id=1) has empty app_modules by design — IS_ADMIN bypasses
  // all API checks server-side, and isSuperUser should bypass nav checks too.
  // For everyone else, fall back to util.getModules() result.
  const isSuperUser = fleetNav.isSuperUser; // national || admin || facility admin
  const canSee = (moduleKey) => isSuperUser || modules[moduleKey] === 1;
  const { logEvent } = useActivityLogger({ logToConsole: true });

  const isFleetActive = location.pathname.startsWith('/fleet');

  const isCaptureActive = ['/roles','/asset-cats','/facilities','/assets-list'].some(p => location.pathname.startsWith(p));
  const isReportsActive = ['/stock-transactions-report','/levels-report','/dashboards-report','/asset-report','/adhoc-report','/logs-audit'].some(p => location.pathname.startsWith(p));

  useEffect(() => { if (isFleetActive)   setFleetOpen(true);   }, [isFleetActive]);
  useEffect(() => { if (isCaptureActive) setCaptureOpen(true); }, [isCaptureActive]);
  useEffect(() => { if (isReportsActive) setReportsOpen(true); }, [isReportsActive]);

  // Device detection
  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isTabletDevice = width >= 768 && width <= 1024;
      const currentOrientation = width > height ? 'landscape' : 'portrait';
      setIsTablet(isTabletDevice);
      setOrientation(currentOrientation);
      if (isTabletDevice && currentOrientation === 'landscape') {
        const body = document.body;
        if (!body.classList.contains('page-sidebar-closed')) {
          body.classList.add('page-sidebar-closed');
          setIsSidebarOpen(false);
        }
      }
    };
    checkDevice();
    window.addEventListener('resize', checkDevice);
    window.addEventListener('orientationchange', checkDevice);
    return () => {
      window.removeEventListener('resize', checkDevice);
      window.removeEventListener('orientationchange', checkDevice);
    };
  }, []);

  const setNavActive = useCallback((e) => {
    const $navItems = $(".nav-item");
    $navItems.removeClass("active");
    const $li = $(e.target).closest("li");
    if (!$li.hasClass("sidebar-mobile-offcanvas-toggler")) {
      $li.addClass("active");
      closeResponsiveSidebar();
      if (logEvent) {
        const href = $li.find('a').attr('href');
        logEvent('Navigation Click', { destination: href, device: isTablet ? 'tablet' : 'desktop', orientation });
      }
    }
  }, [logEvent, isTablet, orientation]);

  const toggleSidebarCollapse = useCallback(() => {
    const body = document.body;
    const isCurrentlyOpen = !body.classList.contains('page-sidebar-closed');
    if (isCurrentlyOpen) { body.classList.add('page-sidebar-closed'); setIsSidebarOpen(false); }
    else { body.classList.remove('page-sidebar-closed'); setIsSidebarOpen(true); }
    if (logEvent) logEvent('Sidebar Toggle', { action: isCurrentlyOpen ? 'collapsed' : 'expanded', device: isTablet ? 'tablet' : 'desktop' });
  }, [logEvent, isTablet]);

  const closeResponsiveSidebar = useCallback((e) => {
    if (e) e.preventDefault();
    $("body").removeClass("page-sidebar-mobile-offcanvas-open");
    $(".page-sidebar-cover").hide();
  }, []);

  const init = useCallback(() => {
    $(".sidebarScrollDiv").css({
      'overflow-y': 'auto',
      'overflow-x': 'hidden',
    });
  }, []);

  const setActiveFromRoute = useCallback(() => {
    const currentPath = location.pathname;
    $(".nav-item").removeClass("active");
    $(".nav-item").each(function () {
      const href = $(this).find('a').attr('href');
      if (href && (currentPath === href || currentPath.startsWith(href + '/'))) {
        $(this).addClass("active");
      }
    });
  }, [location.pathname]);

  useEffect(() => {
    setModules(util.getModules());
    init();
    setTimeout(setActiveFromRoute, 100);

    let resizeTimeout;
    const handleResize = () => { clearTimeout(resizeTimeout); resizeTimeout = setTimeout(init, 150); };
    $(window).off("resize.leftnav").on("resize.leftnav", handleResize);

    const style = document.createElement('style');
    style.innerHTML = `
      .page-sidebar {
        background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%) !important;
        border-right: 1px solid #e2e8f0 !important;
        box-shadow: 2px 0 20px rgba(0,0,0,0.08) !important;
        transition: all 0.3s cubic-bezier(0.4,0,0.2,1) !important;
      }

      /* ── Sidebar scroll container ── */
      .sidebarScrollDiv {
        height: calc(100vh - 60px) !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
        padding-bottom: 48px !important;
        box-sizing: border-box !important;
      }
      .sidebarScrollDiv::-webkit-scrollbar { width: 5px; }
      .sidebarScrollDiv::-webkit-scrollbar-track { background: transparent; }
      .sidebarScrollDiv::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
      .sidebarScrollDiv::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
      .sidebarScrollDiv { scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent; }

      .page-sidebar-menu { padding: 16px !important; }
      .page-sidebar-menu > .nav-item { margin-bottom: 4px !important; }
      .page-sidebar-menu > .nav-item > .nav-link {
        display: flex !important; align-items: center !important;
        padding: 12px 16px !important; border-radius: 12px !important;
        background: white !important; border: 1px solid #e2e8f0 !important;
        color: #475569 !important; font-weight: 500 !important; font-size: 14px !important;
        text-decoration: none !important; transition: all 0.3s cubic-bezier(0.4,0,0.2,1) !important;
        box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important; min-height: 44px !important;
      }
      .page-sidebar-menu > .nav-item > .nav-link:hover {
        background: #f0f4f8 !important; border-color: #1a3a5c !important;
        color: #1a3a5c !important; transform: translateY(-1px) !important;
        box-shadow: 0 4px 12px rgba(26,58,92,0.1) !important;
      }
      .page-sidebar-menu > .nav-item.active > .nav-link {
        background: #1a3a5c !important;
        border-color: #1a3a5c !important; color: white !important;
        box-shadow: 0 4px 14px rgba(26,58,92,0.3) !important;
        transform: translateY(-1px) !important;
      }
      .page-sidebar-menu > .nav-item.active > .nav-link img { filter: brightness(0) invert(1) !important; }
      .page-sidebar-menu > .heading { margin: 24px 0 12px 0 !important; padding: 0 16px !important; }
      .page-sidebar-menu > .heading > h3 {
        font-size: 11px !important; font-weight: 700 !important; color: #64748b !important;
        letter-spacing: 1px !important; margin: 0 !important; display: flex !important; align-items: center !important;
      }
      .page-sidebar-menu > .heading > h3::before {
        content: ''; width: 4px; height: 16px;
        background: #1a3a5c;
        margin-right: 8px; border-radius: 2px;
      }
      .page-sidebar-menu > .heading > h3::after {
        content: ''; flex: 1; height: 1px;
        background: linear-gradient(to right, #cbd5e1, transparent); margin-left: 12px;
      }

      /* ── Fleet submenu parent ── */
      .fleet-parent-btn {
        display: flex !important; align-items: center !important; width: 100% !important;
        padding: 12px 16px !important; border-radius: 12px !important;
        background: linear-gradient(135deg, #0f172a, #1e3a5f) !important;
        border: 1px solid #1e3a5f !important; color: white !important;
        font-weight: 500 !important; font-size: 14px !important;
        cursor: pointer !important;
        transition: all 0.3s cubic-bezier(0.4,0,0.2,1) !important;
        box-shadow: 0 4px 14px rgba(15,23,42,0.35) !important;
        min-height: 44px !important; text-align: left !important;
        outline: none !important;
      }
      .fleet-parent-btn:hover {
        background: linear-gradient(135deg, #1e3a5f, #1a3a5c) !important;
        box-shadow: 0 6px 20px rgba(15,23,42,0.45) !important;
        transform: translateY(-1px) !important;
      }
      .fleet-parent-btn img { filter: brightness(0) invert(1) !important; }
      .fleet-parent-btn .fleet-arrow {
        margin-left: auto; font-size: 10px; color: rgba(255,255,255,0.7);
        transition: transform 0.3s ease;
      }
      .fleet-parent-btn.open .fleet-arrow { transform: rotate(90deg); }

      /* ── Fleet submenu ── */
      .fleet-submenu {
        list-style: none !important; padding: 6px 0 6px 12px !important;
        margin: 4px 0 0 0 !important; overflow: hidden !important;
        transition: max-height 0.3s ease, opacity 0.3s ease !important;
      }
      .fleet-submenu.closed { max-height: 0 !important; opacity: 0 !important; padding: 0 0 0 12px !important; }
      .fleet-submenu.open  { max-height: 2000px !important; opacity: 1 !important; }
      .fleet-submenu li { margin-bottom: 4px !important; }
      .fleet-submenu li a {
        display: flex !important; align-items: center !important;
        padding: 9px 14px !important; border-radius: 8px !important;
        background: white !important; border: 1px solid #e2e8f0 !important;
        color: #475569 !important; font-size: 13px !important; font-weight: 500 !important;
        text-decoration: none !important;
        transition: all 0.25s ease !important;
        box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
      }
      .fleet-submenu li a:hover {
        background: #f0f4f8 !important; border-color: #1a3a5c !important;
        color: #1a3a5c !important; transform: translateX(3px) !important;
      }
      .fleet-submenu li a:hover img { filter: brightness(0) saturate(100%) invert(15%) sepia(50%) saturate(800%) hue-rotate(195deg) brightness(90%) contrast(95%) !important; }
      .fleet-submenu li.active-sub a {
        background: #1a3a5c !important;
        border-color: #1a3a5c !important; color: white !important;
        box-shadow: 0 4px 12px rgba(26,58,92,0.3) !important;
      }
      .fleet-submenu li.active-sub a img { filter: brightness(0) invert(1) !important; }

      /* ── Active state — single corporate navy colour for all non-fleet items ── */
      .page-sidebar-menu > .nav-item.active > .nav-link {
        background: #1a3a5c !important;
        border-color: #1a3a5c !important;
        color: white !important;
        box-shadow: 0 4px 14px rgba(26,58,92,0.3) !important;
      }
      .page-sidebar-menu > .nav-item.active > .nav-link img {
        filter: brightness(0) invert(1) !important;
      }

      /* ── Sidebar toggle button ── */
      .sidebar-toggle-btn {
        position:fixed; left:240px; top:70px; z-index:1000;
        background:white; border:2px solid #e2e8f0; border-radius:50%;
        width:40px; height:40px; display:flex; align-items:center; justify-content:center;
        cursor:pointer; box-shadow:0 4px 12px rgba(0,0,0,.1); transition:all .3s ease;
      }
      .sidebar-toggle-btn:hover { background:#1a3a5c; border-color:#1a3a5c; transform:scale(1.1); }
      .sidebar-toggle-btn:hover svg { fill:white; }
      .sidebar-toggle-btn svg { width:20px; height:20px; fill:#64748b; transition:all .3s ease; }
      body.page-sidebar-closed .sidebar-toggle-btn { left:60px; }
      body.page-sidebar-closed .sidebar-toggle-btn svg { transform:rotate(180deg); }

      @media (prefers-reduced-motion: reduce) {
        .page-sidebar, .page-sidebar-menu > .nav-item > .nav-link,
        .fleet-parent-btn, .fleet-submenu, .sidebar-toggle-btn
          { transition:none !important; animation:none !important; }
      }
    `;
    document.head.appendChild(style);

    return () => {
      $(window).off("resize.leftnav");
      clearTimeout(resizeTimeout);
      if (document.head.contains(style)) document.head.removeChild(style);
    };
  }, [init, setActiveFromRoute]);

  useEffect(() => { setActiveFromRoute(); }, [location.pathname, setActiveFromRoute]);

  return (
    <>
      <div className="page-sidebar-cover" onClick={closeResponsiveSidebar}></div>

      <div className="sidebar-toggle-btn" onClick={toggleSidebarCollapse}
        title={isSidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
        role="button" aria-label={isSidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}>
        <svg viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" /></svg>
      </div>

      <div className="page-sidebar-wrapper d-print-none">
        <div className="page-sidebar navbar-collapse1 collapse1">
          <div className="sidebarScrollDiv">
            <ul className="page-sidebar-menu page-header-fixed"
              data-keep-expanded="false" data-auto-scroll="true"
              data-slide-speed="200" onClick={setNavActive}>

              <li className="sidebar-mobile-offcanvas-toggler d-lg-none">
                <a href="/" className="responsive-toggler" onClick={closeResponsiveSidebar}>
                  <i className="icon-logout"></i>
                </a>
              </li>

            </ul>

            {/* ── Capture Data accordion ── */}
            <div style={{ padding: '0 16px 8px' }}>
              <button
                className={`fleet-parent-btn${captureOpen ? ' open' : ''}`}
                onClick={() => setCaptureOpen(o => !o)}
                aria-expanded={captureOpen}
              >
                <NavIcon icon="circle" alt="Capture" />
                <span style={{ flex: 1 }}>Capture Data</span>
                <span className="fleet-arrow">&#9654;</span>
              </button>

              <ul className={`fleet-submenu${captureOpen ? ' open' : ' closed'}`}>
                {canSee('manage_roles_users') && (
                <li className={location.pathname.startsWith('/roles') ? 'active-sub' : ''}>
                  <Link to="/roles">
                    <NavIcon icon="user" alt="Roles & Users" />
                    Roles &amp; Users
                  </Link>
                </li>
                )}
                {canSee('manage_cmasters') && (
                <li className={location.pathname.startsWith('/asset-cats') ? 'active-sub' : ''}>
                  <Link to="/asset-cats">
                    <NavIcon icon="gear" alt="Master Control" />
                    Master Control
                  </Link>
                </li>
                )}
                {canSee('manage_facilities') && (
                <li className={location.pathname.startsWith('/facilities') ? 'active-sub' : ''}>
                  <Link to="/facilities">
                    <NavIcon icon="plus" alt="Facilities" />
                    Facilities
                  </Link>
                </li>
                )}
                {canSee('view_asset') && (
                <li className={location.pathname.startsWith('/assets-list') ? 'active-sub' : ''}>
                  <Link to="/assets-list">
                    <NavIcon icon="circle" alt="Capture Assets" />
                    Capture Assets
                  </Link>
                </li>
                )}
              </ul>
            </div>

            {/* ── Reports accordion ── */}
            <div style={{ padding: '0 16px 8px' }}>
              <button
                className={`fleet-parent-btn${reportsOpen ? ' open' : ''}`}
                onClick={() => setReportsOpen(o => !o)}
                aria-expanded={reportsOpen}
              >
                <NavIcon icon="chart" alt="Reports" />
                <span style={{ flex: 1 }}>Reports</span>
                <span className="fleet-arrow">&#9654;</span>
              </button>

              <ul className={`fleet-submenu${reportsOpen ? ' open' : ' closed'}`}>
                {canSee('view_reports_inventory') && (
                <li className={location.pathname.startsWith('/stock-transactions-report') ? 'active-sub' : ''}>
                  <Link to="/stock-transactions-report">
                    <NavIcon icon="business" alt="Transactions" />
                    Transactions Dashboards
                  </Link>
                </li>
                )}
                {canSee('view_levels_dashboard') && (
                <li className={location.pathname.startsWith('/levels-report') ? 'active-sub' : ''}>
                  <Link to="/levels-report">
                    <NavIcon icon="chart" alt="Levels" />
                    Levels Dashboards
                  </Link>
                </li>
                )}
                {canSee('view_reports_dashboards') && (
                <li className={location.pathname.startsWith('/dashboards-report') ? 'active-sub' : ''}>
                  <Link to="/dashboards-report">
                    <NavIcon icon="chart" alt="Inventory Dashboards" />
                    Inventory Dashboards
                  </Link>
                </li>
                )}
                {canSee('view_reports_inventory') && (
                <li className={location.pathname.startsWith('/asset-report') ? 'active-sub' : ''}>
                  <Link to="/asset-report">
                    <NavIcon icon="business" alt="Inventory Reports" />
                    Inventory Reports
                  </Link>
                </li>
                )}
                {canSee('view_reports_logs') && (
                <li className={location.pathname.startsWith('/adhoc-report') ? 'active-sub' : ''}>
                  <Link to="/adhoc-report">
                    <NavIcon icon="paint" alt="Adhoc Reports" />
                    Adhoc Reports
                  </Link>
                </li>
                )}
                {canSee('view_reports_logs') && (
                <li className={location.pathname.startsWith('/logs-audit') ? 'active-sub' : ''}>
                  <Link to="/logs-audit">
                    <NavIcon icon="paint" alt="Logs Dashboards" />
                    Logs Dashboards
                  </Link>
                </li>
                )}
              </ul>
            </div>

            {/* Fleet accordion — outside onClick ul */}
            <div style={{ padding: '0 16px 16px' }}>
              <button
                className={`fleet-parent-btn${fleetOpen ? ' open' : ''}`}
                onClick={() => setFleetOpen(o => !o)}
                aria-expanded={fleetOpen}
              >
                <NavIcon icon="truck" alt="Fleet" />
                <span style={{ flex: 1 }}>Fleet Management</span>
                <span className="fleet-arrow">&#9654;</span>
              </button>

              <ul className={`fleet-submenu${fleetOpen ? ' open' : ' closed'}`}>
                {fleetNavVisible('noticeBoard') && (
                <li className={location.pathname === '/fleet-notice-board' ? 'active-sub' : ''}
                    style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: 4, paddingBottom: 4 }}>
                  <Link to="/fleet-notice-board"
                    style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                    <NavIcon icon="bell" alt="Notice Board" />
                    <span style={{ flex: 1 }}>Notice Board</span>
                  </Link>
                </li>
                )}
                {fleetNav.isSuperUser && (
                <li className={location.pathname === '/fleet-audit-log' ? 'active-sub' : ''}
                    style={{ borderBottom:'1px solid rgba(255,255,255,0.08)' }}>
                  <Link to="/fleet-audit-log">
                    <NavIcon icon="gear" alt="Audit Log" />
                    <span style={{ flex:1 }}>Audit Log</span>
                  </Link>
                </li>
                )}
                {fleetNavVisible('dashboard') && (
                <li className={location.pathname === '/fleet-dashboard' ? 'active-sub' : ''}>
                  <Link to="/fleet-dashboard">
                    <NavIcon icon="chart" alt="Dashboard" />
                    Fleet Dashboard
                  </Link>
                </li>
                )}
                {fleetNavVisible('assignments') && (
                <li className={location.pathname === '/fleet-assignments' ? 'active-sub' : ''}>
                  <Link to="/fleet-assignments">
                    <NavIcon icon="user" alt="Assignments" />
                    Driver Assignments
                  </Link>
                </li>
                )}
                {fleetNavVisible('deployments') && (
                <li className={location.pathname === '/fleet-deployments' ? 'active-sub' : ''}>
                  <Link to="/fleet-deployments">
                    <NavIcon icon="truck" alt="Deployments" />
                    Deployments
                  </Link>
                </li>
                )}
                {fleetNavVisible('trips') && (
                <li className={location.pathname === '/fleet-trip-logs' ? 'active-sub' : ''}>
                  <Link to="/fleet-trip-logs">
                    <NavIcon icon="truck" alt="Trips" />
                    Trip Logs
                  </Link>
                </li>
                )}
                {fleetNavVisible('maintenance') && (
                <li className={location.pathname === '/fleet-maintenance' ? 'active-sub' : ''}>
                  <Link to="/fleet-maintenance">
                    <NavIcon icon="screw" alt="Maintenance" />
                    Maintenance Log
                  </Link>
                </li>
                )}
                {fleetNavVisible('disposals') && (
                <li className={location.pathname === '/fleet-disposals' ? 'active-sub' : ''}>
                  <Link to="/fleet-disposals">
                    <NavIcon icon="screw" alt="Disposals" />
                    Disposal Register
                  </Link>
                </li>
                )}
                {fleetNavVisible('incidents') && (
                <li className={location.pathname === '/fleet-incidents' ? 'active-sub' : ''}>
                  <Link to="/fleet-incidents">
                    <span style={{ marginRight: '12px', display: 'inline-flex', alignItems: 'center' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="15" width="15" viewBox="0 0 512 512" style={{ filter: 'brightness(0.8)' }}>
                      <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.5-34.7-19.9s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
                    </svg>
                  </span>
                    Incident Log
                  </Link>
                </li>
                )}
                {fleetNavVisible('reports') && (
                <li className={location.pathname.startsWith('/fleet-reports') || location.pathname.startsWith('/fleet/report') ? 'active-sub' : ''}>
                  <Link to="/fleet-reports">
                    <NavIcon icon="screw" alt="Reports" />
                    Fleet Reports
                  </Link>
                </li>
                )}

                {/* ── Analytics ──────────────────────────────────────────── */}
                {fleetNav.anyAnalytics && (
                <li style={{ marginTop:6, paddingTop:6, borderTop:'1px solid rgba(255,255,255,0.1)' }}>
                  <span style={{ fontSize:9, fontWeight:500, color:'rgba(255,255,255,0.35)',
                    textTransform:'uppercase', letterSpacing:'.08em', padding:'2px 8px',
                    display:'block' }}>Analytics</span>
                </li>
                )}
                {(fleetNav.analyticsExec || fleetNav.isSuperUser) && (
                <li className={location.pathname === '/fleet-analytics-exec' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-exec">
                    <NavIcon icon="chart" alt="Exec Summary" />
                    Exec Summary
                  </Link>
                </li>
                )}
                {fleetNavVisible('analyticsDepreciation') && (
                <li className={location.pathname === '/fleet-analytics-depreciation' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-depreciation">
                    <NavIcon icon="chart" alt="Depreciation" />
                    Depreciation vs Cost
                  </Link>
                </li>
                )}
                {fleetNavVisible('analyticsCostPerKm') && (
                <li className={location.pathname === '/fleet-analytics-cost-per-km' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-cost-per-km">
                    <NavIcon icon="screw" alt="Cost per KM" />
                    Cost per KM
                  </Link>
                </li>
                )}
                {fleetNavVisible('analyticsRepairReplace') && (
                <li className={location.pathname === '/fleet-analytics-repair-replace' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-repair-replace">
                    <NavIcon icon="gear" alt="Repair vs Replace" />
                    Repair vs Replace
                  </Link>
                </li>
                )}
                {fleetNavVisible('analyticsProgrammeCost') && (
                <li className={location.pathname === '/fleet-analytics-programme-cost' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-programme-cost">
                    <NavIcon icon="business" alt="Programme Costs" />
                    Programme Costs
                  </Link>
                </li>
                )}
                {fleetNavVisible('analyticsDriverScorecard') && (
                <li className={location.pathname === '/fleet-analytics-driver-scorecard' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-driver-scorecard">
                    <NavIcon icon="user" alt="Driver Scorecard" />
                    Driver Scorecard
                  </Link>
                </li>
                )}
                {fleetNavVisible('analyticsUtilisation') && (
                <li className={location.pathname === '/fleet-analytics-utilisation' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-utilisation">
                    <NavIcon icon="chart" alt="Utilisation" />
                    Utilisation Heatmap
                  </Link>
                </li>
                )}
                {fleetNavVisible('analyticsFuelIntelligence') && (
                <li className={location.pathname === '/fleet-analytics-fuel-intelligence' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-fuel-intelligence">
                    <NavIcon icon="truck" alt="Fuel Intelligence" />
                    Fuel Intelligence
                  </Link>
                </li>
                )}
                {fleetNavVisible('analyticsDeployments') && (
                <li className={location.pathname === '/fleet-analytics-deployments' ? 'active-sub' : ''}>
                  <Link to="/fleet-analytics-deployments">
                    <NavIcon icon="truck" alt="Deployments Analytics" />
                    Deployment Analytics
                  </Link>
                </li>
                )}
              </ul>
            </div>

          </div>{/* end sidebarScrollDiv */}
        </div>
      </div>
    </>
  );
}